// extracted by mini-css-extract-plugin
export default {"ModalWrapper":"PointUsersComparisonModal_ModalWrapper__6i+dy","Wrapper":"PointUsersComparisonModal_Wrapper__q7uVn"};